<template>
    <svg
        height="24px"
        width="24px"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 38.889 27.62"
        fill="none"
        stroke="currentColor"
    >
        <g id="scooter" transform="translate(0.5 0.5)">
            <path
                id="layer2"
                d="M16.1,43.263a5.052,5.052,0,0,1-10.1,0M39.279,42a5.052,5.052,0,1,1-9.788,0"
                transform="translate(-3.474 -21.793)"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
            />
            <path
                id="layer1"
                d="M36.489,10h2.526a2.722,2.722,0,0,1,2.526,2.526V24.019c0,2.021-1.831,6.631-7.641,6.631"
                transform="translate(-13.756 -10)"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
            />
            <path
                id="layer1-2"
                data-name="layer1"
                d="M29.785,31.263h3.789c6.125,0,6.315,6.315,6.315,6.315H25.049M10.841,30A8.841,8.841,0,0,0,2,38.841H22.207A8.841,8.841,0,0,0,13.367,30Z"
                transform="translate(-2 -17.37)"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
            />
            <path
                id="layer1-3"
                data-name="layer1"
                d="M15.829,19.42H2c.631,3.852,4.357,5.052,8.778,5.052H13.3A13.387,13.387,0,0,0,19.05,23.4C21.007,22.325,21.2,19.42,15.829,19.42ZM32.942,15v3.789"
                transform="translate(-2 -11.843)"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
            />
        </g>
    </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
    name: "oss-chevron-right",
});
</script>
